import React from "react";
import SuccessModal from "../../../../organisms/Modal/SuccessModal/SuccessModal";
import ErrorModal from "../../../../organisms/Modal/ErrorModal/ErrorModal";
import {NoSsr} from "@material-ui/core";
import {isDefined} from "../../../../../utils";
import {compose} from "recompose";
import {withTranslation} from "react-i18next";
let t=null;

class OfferApprove extends React.Component {

    constructor(props){
        super(props);
        t = props.t;
    }

    showMessages = () => {

        if( this.props.approveOffer.offerData && this.props.approveOffer.offerData.status === 200 ){
            return <SuccessModal status={true} message={ t('enw-offer-approve-message') } />
        } else if (isDefined(this.props.approveOffer.error.response) ) {
            let message = this.props.approveOffer.error.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    render() {
        return (
            <NoSsr>
                {
                    !this.props.approveOffer.fetching &&
                        <NoSsr>
                            {
                                this.showMessages()
                            }
                        </NoSsr>
                }

            </NoSsr>
        )
    }
}

export default compose(withTranslation('common')) (OfferApprove);
